<script>
import ModuleTitle from '../common/ModuleTitle.vue'
import AudioPlayer61 from 'comp/common/AudioPlayer/AudioPlayer61'
import CheckMoreText from '../common/CheckMoreText.vue'

import { mapGetters } from 'vuex'
import { getShadowColor } from '@/utils/modules/getStyles'

export default {
  name: 'Comp61',
  components: { ModuleTitle, AudioPlayer61, CheckMoreText },
  props: {
    moduleOption: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      path: this.$route.path,
      audioList: this.moduleOption.list
    }
  },
  computed: {
    ...mapGetters({
      currentModalNameGetter: 'config/getCurrentModalName',
      dialogIsShowGetter: 'config/getDialogIsShow'
    }),
    currentModalName() {
      return this.currentModalNameGetter
    },
    dialogIsShow: {
      get() {
        return this.dialogIsShowGetter
      },
      set(v) {}
    }
  },
  watch: {
    dialogIsShow(newVal, oldVal) {
      if (newVal) {
        this.audioList.forEach(item => {
          item.isplaying = false
        })
      }
    }
  },
  created() {
    this.audioList.forEach(item => this.$set(item, 'isplaying', false))
  },
  methods: {
    getShadowColor,
    handleAudioClick(idx) {
      this.audioList.forEach((item, index) => {
        index === idx
          ? item.isplaying = !item.isplaying
          : item.isplaying ? item.isplaying = false : ''
      })
    },
    onCheckMore() {
      this.$store.commit('config/SET_CURRENT_MODALNAME', this.moduleOption.title)
      this.$store.commit('config/SET_DIALOG', true)
    }
  }
}
</script>

<template>
  <div class="modules-id-61">
    <module-title :title="moduleOption.title" margin-bottom="24" />
    <div class="comp-transverse-2 modules-id-61-content pointer">
      <AudioPlayer61
        v-for="(v, i) in audioList.slice(0, 3)"
        :key="`modules-61-${i}`"
        ref="audioGroup"
        :audiourl="v.typename"
        :title="v.headline"
        :publisher="v.name"
        :idx="i"
        :isplaying="v.isplaying"
        @handleAudioClick="handleAudioClick"
      />
      <check-more-text class="check-comp" @click.native="onCheckMore" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.modules-id-61-content {
  display: flex;
  column-gap: 20px;
  position: relative;
  .check-comp {
    position: absolute;
    bottom: 0;
    left: 44%;
  }
}
</style>
